<template>
  <!-- <div class="drag"> -->
  <div class="content">
    <div class="cont-list">
      <span class="list">{{
        this.$route.query.name + "-" + this.title + "流程"
      }}</span>
    </div>
    <div class="bottom">
      <div class="siderMenu">
        <div style="overflow-y:auto;height:calc(100% - 50px)">
          <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
            <div class="wfcard-content">
              <div style="width:88%;display: flex">
                <div class="start-label" />
                <span class="text">流程配置</span>
              </div>
              <div style="padding:0 10px">
                <el-form-item label="流程名称" prop="name">
                  <el-input v-model="form.name" :disabled="!editMode" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="form.remark" :disabled="!editMode" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="流程配置" v-if="editMode" prop="remark">
                  <div class="wfcard-remark">拖拽区域内节点进行流程配置</div>
                  <!-- <div class="wf-code-setting handwork" data-type="fillSheet" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
                    <i class="iconfont icon-tianjia" style="height:20px;width:20px;color:rgb(40, 106, 180, 0.5);margin-left:20px"></i>
                    <span style="margin-left:20px">添加发起节点</span>
                  </div> -->
                  <div class="wf-code-setting approve" data-type="operation" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
                    <i class="iconfont icon-ziyuan203" style="height:20px;width:20px;color:rgb(40, 106, 180, 0.5);margin-left:20px"></i>
                    <span style="margin-left:20px">添加审批节点</span>
                  </div>
                  <div class="wf-code-setting send" data-type="sendMessage" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
                    <i class="iconfont icon-ziyuan201" style="height:20px;width:20px;color:rgb(40, 106, 180, 0.5);margin-left:20px"></i>
                    <span style="margin-left:20px">添加抄送节点</span>
                  </div>
                </el-form-item>
                <div v-else style="height:20px"></div>
              </div>
            </div>
          </el-form>

          <div class="wfcard-content" v-if="editMode">
            <div style="width:88%;display: flex">
              <div class="start-label" />
              <span class="text">节点配置</span>
            </div>
            <div style="padding:0 10px 5px">
              <el-form label-position="top" label-width="80px" ref="nodeForm" :model="nodeForm" :rules="nodeRules">
                <el-form-item label="节点名称" prop="name">
                  <el-input :disabled="!nodeDialogVisible" v-model="nodeForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="绑定人员" prop="remark">
                  <div class="bind-user">关联人员</div>
                  <div class="bind-user-btn">
                    <span v-if="
                        nodeForm.type === 'operation' ||
                          nodeForm.type === 'sendMessage'
                      " class="bottom-line pointer" v-preventReClick @click="showBindUserDialog">
                      + 点击此处关联人员</span>
                    <span v-else style="color:#C0C4CC">
                      + 点击此处关联人员</span>
                  </div>
                </el-form-item>
                <el-form-item label="设定人员规则" prop="remark">
                  <el-radio-group :disabled="nodeForm.type !== 'operation'" v-model="nodeForm.rule" class="pass-rule">
                    <el-radio :label="0" style="color: #999999;"><span>以上人员均需参与操作</span></el-radio>
                    <el-radio :label="1" style="color: #999999;">以上人员任意一位参与操作，<br /><span style=" margin-left:23px">并将结果抄送至相关人员</span></el-radio>
                    <el-radio :label="2" style="color: #999999;">自定义</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div class="wf-user-count">
                  <span>该流程需要</span>
                  <el-input-number :disabled="nodeForm.rule !== 2" v-model="nodeForm.personNumber" :min="1" :controls="false" style="width:46px"></el-input-number>
                  <span>人参与</span>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <div class="footer-btn">
          <el-button class="btn primary" v-if="editMode" v-loading="loading" :disabled="loading" type="primary" style="height:40px;width:100%" size="small" v-preventReClick @click="handleChartSave">保存流程</el-button>
          <el-button class="btn primary" v-else type="primary" style="height:40px;width:100%" size="small" v-preventReClick @click="cancel">返回</el-button>
        </div>
      </div>

      <div class="right">
        <div class="dragMain">
          <div class="dragArea" @drop.prevent="drop" @dragover.prevent>
            
            <flowchart :selectUserVisible="selectUserVisible" :nodes="form.nodes" :connections="form.connections" @editnode="handleEditNode" @showNodeUsers="showNodeUsers" @closePopover="closePopover" :width="'100%'" :height="'100%'" :readonly="false" @editconnection="handleEditConnection" ref="chart" @close="nodeDialogClose" @submit="nodeDialogSubmit" :node="JSON.parse(JSON.stringify(nodeForm))" :attrList="attrList" @handleChartMouseDown="handleChartMouseDown" @clickConnection="clickConnection"></flowchart>
            <!-- 条件设置 -->
            <el-popover ref="connection_popover" class="area_popper" placement="right" width="400" :visible-arrow="true" trigger="click" :style="
                'left:' +
                  (connectionOffsetX + 30) +
                  'px;top:' +
                  (connectionOffsetY - 28) +
                  'px;'
              " v-model="connectionDialogVisible">
              <div class="popover-content">
                <div class="popover-content-head">
                  <div class="popover-title">条件设置</div>
                  <i class="el-icon-close popover-close" v-preventReClick @click="connectionDialogVisible = false"></i>
                </div>
                <el-form label-position="top" label-width="80px" ref="connectionForm" :model="connectionForm" :rules="rules">
                  <el-form-item label="" prop="">
                    <!-- <el-input v-model="form.name" placeholder="请选择控件名称" style="width:31%;"></el-input> -->
                    <el-select v-model="connectionForm.conditionCode" :disabled="!editMode" style="width: 31%;" placeholder="请选择控件名称" @change="controlChange">
                      <el-option v-for="item in attrList" :key="item.key" :label="item.name" :value="item.key">
                      </el-option>
                    </el-select>
                    <el-select v-model="connectionForm.conditionType" :disabled="!editMode" style="width: 31%;margin-left:10px;" placeholder="请选择条件">
                      <el-option v-for="item in CompareOptions" :key="item.id" :label="item.name" :value="item.id">
                      </el-option>
                    </el-select>
                    <!-- <el-input v-model="form.name" placeholder="请选择条件" style="width:31%;margin-left:10px"></el-input> -->
                    <!-- <el-input v-model="form.name" placeholder="请输入数字" style="width:31%;margin-left:10px"></el-input> -->
                    <el-input-number v-model="connectionForm.conditionValue" :disabled="!editMode" :min="0" :precision="2" :controls="false" placeholder="请输入数字" style="width:31%;margin-left:10px"></el-input-number>
                  </el-form-item>
                </el-form>
                <div class="dialog-footer">
                  <el-button class="btn" size="small" v-if="editMode" v-preventReClick @click="connectionClear">清 空</el-button>
                  <el-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="connectionDialogSubmit">确 定</el-button>
                </div>
                <div class="pop-arrow"></div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>

      <el-dialog :title="nodeUserDialogTitle" :visible.sync="nodeUserDialogVisible" :modal="false" custom-class="node-user-dialog" @before-close="closeNodeUserDialog" :show-close="false" width="400px">
        <div class="node-user-div">
          <template v-for="item in nodeUsers">
            <div :key="item.id" class="value">
              <span>{{ item.no ? item.no + " " : "" }}{{ item.name + " " }}
              </span>
            </div>
          </template>
        </div>
      </el-dialog>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
// import ConnectionDialog from "./ConnectionDialog";
// import NodeDialog from "./NodeDialog";
// import NodeDialogBySendMessage from "./NodeDialogBySendMessage";

import Flowchart from "./flowchart/Flowchart";
import GetDataMixin from "@/mixin/getData-mixin";
import {
  GetModules,
  GetUserList,
  SaveWorkFlowTemp,
  GetWorkFlowTempById,
  CASLGetWorkFlowTempById,
  GetApproveConditionKeys,
  CASLGetApproveConditionKeys,
} from "@/api";
import { CompareOptions } from "@/enum";

export default {
  name: "drag",
  mixins: [GetDataMixin],
  components: {
    // ConnectionDialog,
    // NodeDialog,
    // NodeDialogBySendMessage,
    Flowchart,
  },
  data: function () {
    return {
      //
      tableData: [],
      total: 0,
      queryParams: {
        keyWord: "",
        pageIndex: 1,
        pageSize: 10,
      },
      multipleSelection: [],
      form: {},
      moduleId: 0,
      attrList: [],
      // nodes: [],
      // connections: [],
      // 节点宽度
      codeWidth: 160,
      // 节点高度
      codeHeight: 50,
      // 流程编辑
      // defaultNodes: [],
      // defaultConnections: [],
      nodeForm: { target: null },
      connectionForm: { target: null, operation: null },
      // 审批节点编辑
      nodeDialogVisible: false,
      // // 其他节点编辑
      // nodeDialogCsVisible: false,
      // 线编辑
      connectionDialogVisible: false,

      nodeUserDialogVisible: false,

      CompareOptions: CompareOptions,
      selectUserVisible: false,
      moduleList: [],
      userList: [],
      aclList: [],
      form: {},
      rules: {
        name: [{ required: true, message: "请输入流程名称", trigger: "blur" }],
      },
      nodeRules: {},
      nodeUsers: [],
      nodeUserDialogTitle: "关联人员",

      // validate
      validateComplete: false,
      validateRound: false,
      validateNodeUser: false,
      validateNodeUserCount: false,
      historyNodes: [],
      connectionOffsetX: 0,
      connectionOffsetY: 0,
      editMode: false
    };
  },
  async mounted () { },
  created () {
    var query = this.$route.query;
    if (query.moduleId) {
      this.moduleId = query.moduleId;
    }
    if (query.id) {
      this.editMode = false;
      
      this.handleUpdate(query.id,query.isMedicine);
    } else {
      this.handleAdd();
      this.editMode = true;
      if (query.workFlowCardId) {
        this.form.workFlowCardId = query.workFlowCardId;
      }
    }

    // this.aclList = this.getTableAcl('WorkFlowTemp');
  },
  watch: {
    nodeDialogVisible (val, oldVal) {
      if (!val) {
        this.nodeForm = {};
      }
    },
  },
  methods: {
    init () {
      this.form.nodes = [
        {
          approvers: [],
          x: 370,
          y: 80,
          type: "start",
          name: "Start",
          code: "start",
          approverIds: "",
          isLeader: 0,
          pageId: "1597046114",
          id: 1597046114,
          width: this.codeWidth,
          height: this.codeHeight,
        },
        {
          approvers: [],
          x: 370,
          y: 380,
          type: "end",
          name: "End",
          code: "end",
          approverIds: "",
          isLeader: 0,
          pageId: "1597046120",
          id: 1597046120,
          width: this.codeWidth,
          height: this.codeHeight,
        },
        {
          approvers: [],
          x: 370,
          y: 180,
          type: "fillSheet",
          name: "发起节点",
          code: "code1",
          approverIds: "",
          isLeader: 0,
          pageId: "1597046124",
          id: 1597046124,
          width: this.codeWidth,
          height: this.codeHeight,
        },
        {
          approvers: [],
          x: 370,
          y: 280,
          type: "operation",
          name: "审批节点",
          code: "code4",
          approverIds: "",
          isLeader: 1,
          pageId: "1597046127",
          id: 1597046127,
          width: this.codeWidth,
          height: this.codeHeight,
          approverType: "2",
          tableControlCode: "CreatedUser",
          tableCodeInfos: [{ key: "CreatedUser", name: "创建人" }],
          rule: 0,
        },
      ];
      this.form.connections = [
        {
          type: "pass",
          souce: "1597046114",
          soucePosition: "bottom",
          dest: "1597046124",
          destPosition: "top",
          conditionKey: null,
          conditionType: 0,
          conditionValue: 0,
          pageId: "1597046132",
          id: 1597046132,
          source: {
            id: 1597046114,
            position: "bottom",
          },
          destination: {
            id: 1597046124,
            position: "top",
          },
        },
        {
          type: "pass",
          souce: "1597046124",
          soucePosition: "bottom",
          dest: "1597046127",
          destPosition: "top",
          conditionKey: "",
          conditionType: 1,
          conditionValue: "0",
          pageId: "1597046150",
          id: 1597046150,
          source: {
            id: 1597046124,
            position: "bottom",
          },
          destination: {
            id: 1597046127,
            position: "top",
          },
        },
        {
          type: "pass",
          souce: "1597046127",
          soucePosition: "bottom",
          dest: "1597046120",
          destPosition: "top",
          conditionKey: null,
          conditionType: 0,
          conditionValue: 0,
          pageId: "1597046154",
          id: 1597046154,
          source: {
            id: 1597046127,
            position: "bottom",
          },
          destination: {
            id: 1597046120,
            position: "top",
          },
        },
      ];
    },
    getModules () {
      GetModules({ type: 3, pageIndex: 1, pageSize: 100 }).then((res) => {
        this.moduleList = res.returnData.data;
      });
    },
    getUsers (keyWord) {
      GetUsers({ pageIndex: 1, pageSize: 100, keyWord: keyWord }).then(
        (res) => {
          this.userList = res.returnData.data;
        }
      );
    },
    getAttrList () {
      if(this.$route.query.isMedicine=='true'){
        CASLGetApproveConditionKeys({ moduleId: this.moduleId }).then((res) => {
        this.attrList = res.returnData;
      });
      }else{
        GetApproveConditionKeys({ moduleId: this.moduleId }).then((res) => {
        this.attrList = res.returnData;
      });
      }
    },
    handleAdd () {
      // this.editMode = true;
      // this.nodes = this.defaultNodes
      // this.connections = this.defaultConnections

      this.resetForm();
      this.init();
      this.getAttrList();
    },
    resetForm () {
      this.form = {
        id: 0,
        name: "",
        remark: "",
        nodes: [],
        connections: [],
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    handleUpdate (id,boolean) {
      this.getAttrList();
      if(boolean=='true'){
        CASLGetWorkFlowTempById({ id }).then((res) => {
        this.resetForm();
        this.editVisible = true;
        this.form = res.returnData;
        // this.form.id = res.returnData.id
        // this.form.tableCode = res.returnData.tableCode
        // this.form.name = res.returnData.name
        // this.form.remark = res.returnData.remark

        this.form.nodes = res.returnData.nodes.map((item) => {
          if (!item.approvers) {
            item.approvers = [];
          } else {
            item.approvers.map((app) => {
              var users = this.userList.filter((e) => e.id == app.id);
              if (!users || users.length == 0) {
                this.userList.push(app);
              }
            });
          }
          return item;
        });
        this.form.connections = res.returnData.connections.map((item) => {
          let obj = item;
          obj.source = { id: item.souce, position: item.soucePosition };
          obj.destination = { id: item.dest, position: item.destPosition };
          obj.conditionKey = item.conditionKey;
          obj.conditionType = item.conditionType;
          obj.conditionValue = item.conditionValue;
          return obj;
        });
        // this.form = res.returnData
      });
      }else{
        GetWorkFlowTempById({ id }).then((res) => {
        this.resetForm();
        this.editVisible = true;
        this.form = res.returnData;
        // this.form.id = res.returnData.id
        // this.form.tableCode = res.returnData.tableCode
        // this.form.name = res.returnData.name
        // this.form.remark = res.returnData.remark

        this.form.nodes = res.returnData.nodes.map((item) => {
          if (!item.approvers) {
            item.approvers = [];
          } else {
            item.approvers.map((app) => {
              var users = this.userList.filter((e) => e.id == app.id);
              if (!users || users.length == 0) {
                this.userList.push(app);
              }
            });
          }
          return item;
        });
        this.form.connections = res.returnData.connections.map((item) => {
          let obj = item;
          obj.source = { id: item.souce, position: item.soucePosition };
          obj.destination = { id: item.dest, position: item.destPosition };
          obj.conditionKey = item.conditionKey;
          obj.conditionType = item.conditionType;
          obj.conditionValue = item.conditionValue;
          return obj;
        });
        // this.form = res.returnData
      });
      }
    
    },
    cancel () {
      this.$router.go(-1)
    },
    // 流程设计方法
    copyStart (ev) {
      let info = { id: ev.target.id, isDrop: true };
      ev.dataTransfer.setData("Text", JSON.stringify(info));
      this.offsetX = ev.offsetX;
      this.offsetY = ev.offsetY;
    },
    drop (e) {
      let info = JSON.parse(e.dataTransfer.getData("Text"));
    },
    dragEnd (event) {
      let type = event.target.dataset.type;
      let name = "";
      let code = "";
      if (type === "fillSheet") {
        name = "发起节点";
        code = "sponsor_code";
      } else if (type === "start") {
        name = "Start";
        code = "start";
      } else if (type === "end") {
        name = "End";
        code = "end";
      } else {
        // 抄送和审批节点
        name = type == "operation" ? "审批节点" : "抄送节点";
        code = "code" + (this.form.nodes.length - 1);
      }

      this.$refs.chart.add({
        id: this.getId(),
        // x: event.pageX - 350,
        // y: event.pageY - 110,
        x: event.offsetX - 310,
        y: event.pageY - 110,
        name: name,
        type: type,
        code: code,
        approvers: [],
        width: this.codeWidth,
        height: this.codeHeight,
        approverType: "2",
        tableControlCode: "CreatedUser",
        tableCodeInfos: [{ key: "CreatedUser", name: "创建人" }],
        rule: 0,
      });
      event.dataTransfer.clearData();
    },
    getId () {
      let date = new Date().getTime();
      return parseInt(date / 1000);
    },
    // 拖拽
    save () {
      this.$refs.chart.save();
    },
    handleDblClick (position) {
      this.$refs.chart.add({
        id: this.getId(),
        x: position.x,
        y: position.y,
        name: "New",
        type: "operation",
        approvers: [],
        width: this.codeWidth,
        height: this.codeHeight,
      });
    },
    async handleChartSave () {
      this.form.nodes = [...this.$refs.chart.internalNodes];
      this.form.connections = [...this.$refs.chart.internalConnections];

      this.form.connections.map((item) => {
        // let obj = {
        item.type = item.type;
        item.souce = item.source.id;
        item.soucePosition = item.source.position;
        item.dest = item.destination.id;
        item.destPosition = item.destination.position;
        item.conditionKey = item.conditionKey;
        item.conditionType = item.conditionType;
        item.conditionValue = item.conditionValue;
        item.id = item.id;
        // }
        return item;
      });
      // return
      // let ids = null
      // for (let item of nodes) {
      //   item.approvers && (ids = item.approvers.map(list => {
      //     return list.id
      //   }))
      //   item.approverIds = ids.join(';')
      //   ids = null
      // }

      this.$refs.form.validate((valid) => {
        this.loading = true
        if (!valid) {
           this.loading = false
          return false;
        }
        let startNum = this.form.nodes.filter((item) => item.type == "start")
          .length;
        let endNum = this.form.nodes.filter((item) => item.type == "end")
          .length;
        let fillSheetNum = this.form.nodes.filter(
          (item) => item.type == "fillSheet"
        ).length;

        let emptyNameNodes = this.form.nodes.filter(
          (item) => !item.name || item.name == ""
        );
        
        if (startNum != 1) {
          this.$my_message("必须且只能有一个起始节点", "warning");
            this.loading = false
          return;
        }
        if (endNum != 1) {
          this.$my_message("必须且只能有一个结束节点", "warning");
            this.loading = false
          return;
        }
        if (fillSheetNum != 1) {
          this.$my_message("必须且只能有一个发起节点", "warning");
            this.loading = false
          return;
        }
        if (emptyNameNodes && emptyNameNodes.length > 0) {
            this.loading = false
          this.$my_message("存在名称为空的节点", "warning");
          return;
        }

        // let obj = {
        //   nodes: this.form.nodes,
        //   connections: this.form.connections,
        //   tableCode: this.form.tableCode,
        //   name: this.form.name,
        //   remark: this.form.remark
        // }
        // 校验审批和抄送必须有人

        // 校验流程是否从开始到结束是完整的
        this.validateRound = false;
        this.validateComplete = false;
        this.validateNodeUser = false;
        this.validateNodeUserCount = false;
        this.historyNodes = [];
        this.validateNodeusers();
        this.validate();
        if (this.validateRound) {
            this.loading = false
          this.$my_message("存在循环流程", "warning");
          return;
        }
        if (!this.validateComplete) {
            this.loading = false
          this.$my_message("没有找到一条从开始到结束的完整流程", "warning");
          return;
        }
        if (this.validateNodeUser) {
            this.loading = false
          this.$my_message("存在没有设置人员的审批或抄送节点", "warning");
          return;
        }
        if (this.validateNodeUserCount) {
            this.loading = false
          this.$my_message(
            "存在审批节点中设置的需要参与的人数大于节点的审批人数",
            "warning"
          );
          return;
        }

        
        SaveWorkFlowTemp(this.form).then((res) => {
          this.$my_message("保存成功", "success");
          this.form.name = "";
          this.form.tableCode = "";
          this.form.remark = "";
          this.loading = false
          sessionStorage.setItem("editMode", 0);
          this.$router.go(-1); // 返回上一级
          // this.$router.push({ path: this.getMainPath(this.$route.path) });//最初始页
        });
      });
    },
    // 校验流程是否从开始到结束是完整的
    validate () {
      let startNode = this.form.nodes.find((item) => item.type == "start");
      this.validateWfRound(startNode);
      this.validateWfComplete(startNode);
    },
    validateWfRound (node) {
      // let res = false;
      let conns = this.form.connections.filter(
        (item) => item.source.id == node.id
      );
      if (conns && conns.length > 0) {
        // 无条件的线
        let destIds = conns
          .filter((e) => !e.conditionCode)
          .map((e) => e.destination.id * 1);
        let nextNodes = this.form.nodes.filter(
          (item) => destIds.indexOf(item.id) != -1
        );
        if (destIds && nextNodes && destIds.length > nextNodes.length) {
          this.validateRound = true;
          return;
        }
        console.log(node, conns, destIds, nextNodes);
        if (nextNodes && nextNodes.length > 0) {
          nextNodes.forEach((nn) => {
            console.log(nn);
            let historyNode = this.historyNodes.find((e) => e.id == nn.id);
            if (historyNode) {
              this.validateRound = true;
              return;
            }
            if (nn.type != "end") {
              this.historyNodes.push(nn);
              this.validateWfRound(nn);
            }
          });
        }
      }
    },
    validateWfComplete (node) {
      let conns = this.form.connections.filter(
        (item) => item.source.id == node.id
      );
      if (conns && conns.length > 0) {
        // 判断完整，不管条件
        let destIds = conns.map((e) => e.destination.id * 1);
        let nextNodes = this.form.nodes.filter(
          (item) => destIds.indexOf(item.id) != -1
        );
        // console.log(node, conns, destIds, nextNodes);
        if (nextNodes && nextNodes.length > 0) {
          nextNodes.forEach((nn) => {
            if (nn.type == "end") {
              this.validateComplete = true;
              return;
            } else {
              this.validateWfComplete(nn);
            }
          });
        }
      }
    },
    validateNodeusers () {
      var nodes = this.form.nodes.filter(
        (e) => e.type == "operation" || e.type == "sendMessage"
      );
      if (nodes) {
        nodes.forEach((n) => {
          let users = this.getNodeusers(n);
          if (!users || users.length == 0) {
            this.validateNodeUser = true;
          }
          
          if (
            n.rule == 2 &&
            (!n.personNumber || n.personNumber > users.length)
          ) {
            this.validateNodeUserCount = true;
          }
        });
      }
    },

    handleEditNode (node) {
      this.nodeForm = node;
      // if (node.type === 'operation') {
      //   this.nodeDialogVisible = true;
      //   // this.nodeDialogCsVisible = false;
      // } else {
      //   this.nodeDialogVisible = false;
      //   this.nodeDialogCsVisible = true;
      // }
      this.nodeDialogVisible = true;
      this.connectionDialogVisible = false;
    },
    handleEditConnection (connection, x, y) {
      this.connectionForm = JSON.parse(JSON.stringify(connection));
      this.connectionOffsetX = x;
      this.connectionOffsetY = y;
      this.connectionDialogVisible = true;
      this.nodeDialogVisible = false;
      // this.nodeDialogCsVisible = false
    },
    connectionDialogSubmit () {
      // console.log(this.connectionForm)
      // this.form.connections.forEach(element => {
      //   if (element.id == this.connectionForm.id) {
      //     return this.connectionForm
      //   }

      //   return element
      // });
      if (
        this.connectionForm.conditionCode &&
        this.connectionForm.conditionValue != null
      ) {
        this.$refs["chart"].connectionFormChange(this.connectionForm);
        // 立马重新绘制
        this.$refs["chart"].renderNodes();
        this.$refs["chart"].renderConnections();

        this.connectionDialogVisible = false;
      } else {
        this.connectionForm.conditionCode = null;
        this.connectionForm.conditionType = null;
        this.connectionForm.conditionValue = null;
        this.$my_message(
          "抱歉！当前条件无法生效。请将条件输入框补充完整！",
          "error"
        );
        this.connectionDialogVisible = false;
      }
    },

    /**
     * 条件清空
     */
    connectionClear () {
      this.connectionForm.conditionCode = null;
      this.connectionForm.conditionType = null;
      this.connectionForm.conditionValue = null;
      this.$refs["chart"].connectionFormChange(this.connectionForm);
      // 立马重新绘制
      this.$refs["chart"].renderNodes();
      this.$refs["chart"].renderConnections();
    },

    showBindUserDialog () {
      if (
        this.nodeForm.type === "operation" ||
        this.nodeForm.type === "sendMessage"
      ) {
        this.selectUserVisible = true;
      }
    },
    nodeDialogClose () {
      this.selectUserVisible = false;
    },
    nodeDialogSubmit (type, data) {
      this.nodeForm.approverType = type;

      this.nodeForm.deptManagerIds = "";
      this.nodeForm.deptInfos = [];
      this.nodeForm.approverIds = "";
      this.nodeForm.approvers = [];
      this.nodeForm.tableControlCode = "";
      this.nodeForm.tableCodeInfos = [];

      if (type == "0") {
        this.nodeForm.deptManagerIds = data.map((e) => e.id).join(";");
        this.nodeForm.deptInfos = data;
      } else if (type == "1") {
        this.nodeForm.approverIds = data.map((e) => e.id).join(";");
        this.nodeForm.approvers = data;
      } else if (type == "2") {
        this.nodeForm.tableControlCode = data.map((e) => e.key).join(";");
        this.nodeForm.tableCodeInfos = data;
      }else if (type == "3"){
        this.nodeForm.tableControlCode = data[0].key
        this.nodeForm.tableCodeInfos = data;
      }else if (type == "4"){
        this.nodeForm.tableControlCode = data[0].key
        this.nodeForm.tableCodeInfos = data;
      }else if (type == "5"){
        this.nodeForm.tableControlCode = data[0].key
        this.nodeForm.tableCodeInfos = data;
      }

      this.nodeForm.approverType = type;
      this.selectUserVisible = false;
    },
    controlChange (val) {
      this.connectionForm.conditionCode = val;
    },
    showNodeUsers (node) {
      this.nodeDialogVisible = false;
      this.selectUserVisible = false;
      if (node.approverType * 1 == 0) {
        this.nodeUsers = node.deptInfos;
        this.nodeUserDialogTitle = "科室负责人";
      } else if (node.approverType * 1 == 1) {
        this.nodeUsers = node.approvers;
        this.nodeUserDialogTitle = "成员";
      } else if (node.approverType * 1 == 2) {
        this.nodeUsers = node.tableCodeInfos;
        this.nodeUserDialogTitle = "智能人员控件";
      }else if (node.approverType * 1 == 3) {
        this.nodeUsers = node.tableCodeInfos;
        this.nodeUserDialogTitle = "高级控件";
      } else {
        this.nodeUsers = [];
      }
      if (this.nodeUsers && this.nodeUsers.length > 0) {
        this.nodeUserDialogVisible = true;
      }
    },
    getNodeusers (node) {
      let users = [];
      if (node.approverType * 1 == 0) {
        users = node.deptInfos;
      } else if (node.approverType * 1 == 1) {
        users = node.approvers;
      } else if (node.approverType * 1 == 2) {
        users = node.tableCodeInfos;
      }else if (node.approverType * 1 == 3) {
        users = node.tableControlCode;
      }else if (node.approverType * 1 == 4) {
        users = node.tableControlCode;
      }else if (node.approverType * 1 == 5) {
        users = node.tableControlCode;
      }

      return users;
    },
    closePopover () {
      this.connectionDialogVisible = false;
    },
    closeNodeUserDialog () {
      this.nodeUserDialogVisible = false;
    },
    handleChartMouseDown () {
      this.nodeDialogVisible = false;
      this.selectUserVisible = false;
    },
    clickConnection (conn) {
      this.nodeDialogVisible = false;
      this.selectUserVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.drag {
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
}
.siderMenu {
  /* width: 100px; */
  height: calc(100% - 25px);
  /* overflow: scroll; */
  overflow: hidden;
  position: relative;
  width: 280px;
  /* height: 837px; */
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  /* opacity: 1; */
  border-radius: 2px;
  margin-left: 2px;
  padding: 10px;
}
.siderItem {
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  position: relative;
  cursor: move;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}
/* .siderItem:first-child {
  left: 0;
  top: 0;
}
.siderItem:nth-child(2) {
  left: 0;
  top: 40px;
}
.siderItem:last-child {
  left: 0;
  top: 80px;
} */
.bottom {
  display: flex;
  flex: 1;
  height: calc(100% - 50px);
  width: calc(100% - 2px);
}
.right {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
.drag .form {
  height: 60px;
  padding-left: 200px;
}
.right .dragMain {
  flex: 1;
  height: 100%;
}
.dragMain {
  display: flex;
}
.dragArea {
  position: relative;
  flex: 1;
  height: 100%;
  /* width: calc(100% - 400px); */
}

.wfcard-content {
  width: 100%;
  background: #f5f6fa;
  border-radius: 2px;
}
.wfcard-remark {
  color: #c8c9cc;
  font-size: 13px;
  font-weight: 400;
  margin-top: -10px;
  margin-left: 10px;
}
.el-form-item {
  margin-bottom: 10px !important;
}

/* 左侧拖拽 */
.wf-code-setting {
  width: 200px;
  height: 40px;
  box-shadow: 0px 2px 4px rgba(162, 169, 199, 0.6);
  margin-bottom: 10px;
  margin-left: 10px;
}
.handwork {
  background: #d1d6ed;
}
.approve {
  background: #d1e1ed;
}
.send {
  background: #d1ede4;
}

.bind-user {
  margin-left: 10px;
  margin-top: -5px;
}
.bind-user-btn {
  margin-left: 10px;
  /* border-bottom: 1px solid #286ab4; */
  color: #286ab4;
  /* margin-top: -10px; */
  line-height: 16px;
  font-weight: 400;
}

.pass-rule {
  line-height: 25px;
  margin-top: 5px;
}

.wf-user-count {
  color: #999999;
  font-size: 14px;
  font-weight: 400;
  margin: -10px 0 10px 23px;
}

.footer-btn {
  position: absolute;
  bottom: 15px;
  width: calc(100% - 40px);
  padding: 0 10px;
}

.node-user-div {
  min-width: 360px;
  min-height: 100px;
  // background: #f5f6fa;
  // margin-top: 30px;
  display: inline-block;
  *display: inline;
  *zoom: 1;
  // padding: 0 15px;
  .value {
    height: 26px;
    background: #e3e4e6;
    border: 1px solid #cdcdcd;
    margin-right: 10px;
    margin-top: 10px;
    line-height: 26px;
    font-size: 12px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    display: block;
    float: left;
    padding: 0 5px;
  }
}
.pop-arrow {
  position: absolute;
  // top: calc(50% - 10px);
  top: 16px;
  left: -16px;
  margin-bottom: 3px;
  // border-right-color: #ebeef5;
  // border-left-width: 0;
  border-width: 6px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 16px solid #ffffff;
  border-bottom: 10px solid transparent;
}
.popover-content {
  .popover-content-head {
    height: 45px;
    .popover-title {
      padding-top: 6px;
      float: left;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 16px;
      color: #303033;
      opacity: 1;
      font-size: 16px;
    }
    .popover-close {
      float: right;
      font-size: 30px;
      color: #bbbbbb;
      font-weight: bold;
    }
    .popover-close:hover {
      cursor: pointer;
    }
  }
}
</style>
